<template>
  <div class="bg-white relative">
    <!-- <EcommBanner /> -->
    <div class="mt-24">
      <div class="lg:px-20 md:px-20 px-4">
        <!-- <EcommAbout /> -->
        <Products />
      </div>
      <!-- <Helpneeds /> -->
    </div>
    <!-- <EcommTestimonials /> -->

    <WhatWeDo />
    <div class="bge3ceff-opa rounded-t-5555">
      <Download />
      <Footer />
    </div>
  </div>
</template>

<script>
import EcommBanner from "./components/EcommBanner.vue";
import EcommAbout from "./components/EcommAbout.vue";
import Products from "./components/Products.vue";
import Helpneeds from "./components/Helpneeds.vue";
import EcommTestimonials from "./components/EcommTestimonials.vue";
import Download from "./components/Download.vue";
import Footer from "../Footer.vue";
import WhatWeDo from "./components/WhatWeDo.vue";

export default {
  components: {
    EcommBanner,
    EcommAbout,
    Products,
    Helpneeds,
    EcommTestimonials,
    Download,
    WhatWeDo,
    Footer,
  },
};
</script>

<style></style>
